import React, { useEffect, useState } from "react";

import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { RotateCcw, RotateCw } from "react-feather";

import { dataURItoFile } from "shared/lib/dataUri";
import { Button } from "shared/ui/Button";
import { Modal } from "shared/ui/Modal";
import { Spinner } from "shared/ui/icons";

import { CropperBox, Loading, RotateRow } from "./styles";

/*
* Обрезка изображения перед загрузкой. Второй случай (после LineChart), когда кит оборачивает
* не MUI, а стороннюю библиотеку, и по той же причине: вызывающий не должен знать, чем именно
* режется картинка.
* */
export enum ImageAspectRatio {
    square = 1,
    rectangle_3_2 = 3 / 2,
}

interface ImageCropperProps {
    open: boolean;
    onClose: () => void;
    image?: File;
    onCrop: (file: File) => Promise<void>;
    aspectRatio: ImageAspectRatio;
}

const MIN_CROP_BOX_SIZE = 200;

export const ImageCropper = ({
    open,
    onClose,
    image,
    onCrop,
    aspectRatio,
}: ImageCropperProps) => {
    const [imageSrc, setImageSrc] = useState<string>("#");
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [cropper, setCropper] = useState<Cropper>();

    useEffect(() => {
        if (!image) {
            setIsLoading(true);
            return;
        }

        const reader = new FileReader();

        reader.onload = () => {
            setImageSrc(reader.result as string);
            setIsLoading(false);
        };

        reader.readAsDataURL(image);
    }, [image]);

    const handleSubmit = async () => {
        if (!cropper) return;

        // Диалог закрываем до загрузки: она идёт в вызывающем и показывает свой прогресс.
        onClose();

        const fileName = `${image.name.split(".")[0]}.jpeg`;
        const canvas = cropper.getCroppedCanvas({ fillColor: "#ffffff" });

        await onCrop(dataURItoFile(canvas.toDataURL("image/jpeg"), fileName));
    };

    return (
        <Modal
            open={open}
            onClose={onClose}
            title="Работа с изображением"
            actions={
                <>
                    <Button variant="text" color="neutral" onClick={onClose}>
                        Отменить
                    </Button>
                    <Button onClick={handleSubmit}>Сохранить</Button>
                </>
            }
        >
            {isLoading ? (
                <Loading>
                    <Spinner color="secondary" />
                </Loading>
            ) : (
                <>
                    <CropperBox>
                        <Cropper
                            src={imageSrc}
                            initialAspectRatio={aspectRatio}
                            aspectRatio={aspectRatio}
                            minCropBoxHeight={MIN_CROP_BOX_SIZE}
                            minCropBoxWidth={MIN_CROP_BOX_SIZE}
                            guides
                            rotatable
                            style={{ height: 500 }}
                            crop={() => {}}
                            onInitialized={setCropper}
                        />
                    </CropperBox>

                    <RotateRow>
                        <Button
                            variant="text"
                            color="neutral"
                            onClick={() => cropper.rotate(-90)}
                        >
                            <RotateCcw />
                        </Button>
                        <Button
                            variant="text"
                            color="neutral"
                            onClick={() => cropper.rotate(90)}
                        >
                            <RotateCw />
                        </Button>
                    </RotateRow>
                </>
            )}
        </Modal>
    );
};
